import { render } from "./LaborByProjectReport.vue?vue&type=template&id=2646b45d"
import script from "./LaborByProjectReport.vue?vue&type=script&lang=js"
export * from "./LaborByProjectReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__